<template>
  <el-drawer :title="title"
             @close="handleClose"
             :visible.sync="showDailog"
             direction="rtl"
             custom-class="demo-drawer"
             ref="drawer">
    <div class="demo-drawer__content">
      <el-form :model="form"
               :rules="rules"
               :label-width="formLabelWidth"
               ref="templateForm">
        <el-form-item label="code"
                      prop="code">
          <el-input v-model="form.code"
                    autocomplete="off"
                    :disabled="enable"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.type')"
                      prop="type">
          <!--<el-input v-model="form.type" autocomplete="off"></el-input>-->
          <zk-dictionary-select type="templateType"
                                v-model="form.type"
                                style="width:100%"
                                :disabled="enable">
          </zk-dictionary-select>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.languange')"
                      prop="language">
          <zk-dictionary-select type="language"
                                v-model="form.language"
                                style="width:100%"
                                :disabled="enable">
          </zk-dictionary-select>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.templateName')"
                      prop="name">
          <el-input v-model.trim="form.name"
                    autocomplete="off"
                    maxlength="200"
                    show-word-limit
                    :disabled="enable"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.title')"
                      prop="subject">
          <el-input v-model.trim="form.subject"
                    autocomplete="off"
                    maxlength="100"
                    show-word-limit
                    :disabled="enable"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.content')"
                      prop="content">
          <el-input type="textarea"
                    :rows="5"
                    show-word-limit
                    :placeholder="this.$t('sysTemplate.tempTips1')+this.$t('sysTemplate.tempTips2')"
                    v-model="form.content"
                    :disabled="enable">
          </el-input>
          <span style="line-heigth:25px">{{$t('sysTemplate.tempTips1')}}<span style="color:red">{{$t('sysTemplate.tempTips2')}}</span></span>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.group')"
                      prop="grouped">
          <el-input v-model="form.grouped"
                    autocomplete="off"
                    :disabled="enable"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('sysTemplate.sign')">
          <el-input type="textarea"
                    :rows="5"
                    :placeholder="this.$t('announcement.inputContent')"
                    v-model="form.signature"
                    maxlength="500"
                    show-word-limit
                    :disabled="enable">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
                   @click="submit">{{$t('common.confirm')}}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  data () {
    return {
      formLabelWidth: '120px',
      form: {
        code: '',
        type: '',
        language: '',
        name: '',
        subject: '',
        content: '',
        grouped: '',
        signature: ''
      },
      rules: {
        code: [{ required: true, message: this.$t('sysTemplate.inputCode'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('sysTemplate.inputType'), trigger: 'blur' }],
        language: [
          { required: true, message: this.$t('sysTemplate.inputLang'), trigger: 'blur' }
        ],
        name: [{ required: true, message: this.$t('sysTemplate.inputName'), trigger: 'blur' }],
        title: [{ required: true, message: this.$t('sysTemplate.inputTitle'), trigger: 'blur' }],
        content: [
          { required: true, message: this.$t('sysTemplate.inputContent'), trigger: 'blur' }
        ],
        grouped: [
          { required: true, message: this.$t('sysTemplate.inputGroup'), trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: function () {
        return {}
      }
    },
    enable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    row: {
      handler (val) {
        Object.assign(this.form, val)
        this.form.content = this.form.content
          .replace(/<\/?.+?>/g, '')
          .replace(/[\r\n]/g, '')
          .replace(/&nbsp;/g, '')
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    showDailog: {
      set: function () {
        return this.dialogVisible
      },
      get: function () {
        return this.dialogVisible
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
      this.form.code = ''
      this.form.type = ''
      this.form.language = ''
      this.form.name = ''
      this.form.subject = ''
      this.form.content = ''
      this.form.grouped = ''
      this.form.signature = ''
    },
    submit () {
      this.$refs.templateForm.validate(valid => {
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/modules/sysOptions/template/templateDailog.vue